<i18n>
    {
        cn: {
            qa: '常见问题？',
            search: '搜索',
        },
        en: {
            qa: 'Q&A',
            search: 'Search',
        }
    }
</i18n>
<script>
import { mapState } from 'vuex';

export default {
    name: "menus",
    data() {
        return {
            keywords: '',
            showSearchPath: ['/talents/star', '/talents/artist', '/talents/ip', '/talents/theme'],
            showQAPath: ['/talents/museum', '/talents/artist', '/talents/ip', '/talents/theme', '/talents/images', 'talents/ipDetail'],
        };
    },
    computed: {
        ...mapState(['talentMenu', 'TMActiveIndex']),
        menu2() {
            return this.talentMenu[this.TMActiveIndex[0]].children
        },
        menu3() {
            return this.talentMenu[this.TMActiveIndex[0]].children[this.TMActiveIndex[1]].children
        },
    },
    components: {},
    mounted() {},
    destroyed() {},
    watch: {
        '$route.query': {
            handler: function (value) {
                // 根据路由设置搜索关键字
                this.keywords = value.s;
            },
            immediate: true
        },
    },
    methods: {
        tapMenu(index) { 
            this.$store.state.TMActiveIndex = [index, 0, 0];
        },
        tapMenu2(index) { 
            this.$store.state.TMActiveIndex = [this.TMActiveIndex[0], index, 0];
        },
        tapMenu3(index) { 
            this.$store.state.TMActiveIndex = [this.TMActiveIndex[0], this.TMActiveIndex[1], index];
        },
        search() { 
            let query = {
                id: this.$route.query.id,
            }
            if (this.keywords) { 
                query.s = this.keywords
            }
            this.$router.push({
                path: this.$route.path,
                query
            })
        },
    },
};
</script>

<template>
    <div class="wrapper">
        <div class="menu layout_main flex flex_column">
            <div class="flex justify_between align_center">
                <div class="list flex type1">
                    <router-link class="item layout_flex_center" 
                    v-for="(item, index) in talentMenu" :key="index" :to="item.link"
                    :class="{checked: TMActiveIndex[0] == index}"
                    @click.native="tapMenu(index)" >
                        {{ item.name }}
                        <!-- <span class="only_pc">{{ item.name }}</span>
                        <span class="only_mobile">{{ item.title }}</span> -->
                    </router-link>
                </div>
                <router-link class="qa only_pc" v-if="showQAPath.some(v => $route.path == v)" to="/talents/qa">{{ $t('qa') }}</router-link>
            </div>
            <div class="flex justify_between">
                <!-- 英文版用小字号 -->
                <div class="list flex type2" :class="{small_text: $i18n.locale === 'en'}">
                    <template v-if="talentMenu.length > 0">
                        <router-link class="item layout_flex_center" 
                        v-for="(item, index) in menu2" :key="index" :to="item.link"
                        :class="{checked: TMActiveIndex[1] == index}"
                        @click.native="tapMenu2(index)">{{ item.name }}</router-link>
                    </template>
                </div>
                <div class="search flex only_pc" v-if="showSearchPath.some(v => $route.path == v)">
                    <input type="text" v-model="keywords" @keyup.enter="search"/>
                    <div class="btn layout_flex_center" @click="search">{{ $t('search') }}</div>
                </div>
            </div>
            <div class="category layout_main flex" v-if="talentMenu.length > 0 && menu3.length > 0">
                <router-link class="item layout_flex_center" v-for="(item, index) in menu3" :key="index" :to="item.link"
                :class="{checked: TMActiveIndex[2] == index}"
                @click.native="tapMenu3(index)">{{ item.name }}</router-link>
            </div>
            <div class="only_mobile">
                <div class="flex align_center justify_between search_mobile">
                    <div class="search flex" v-if="showSearchPath.some(v => $route.path == v)">
                        <input type="text" v-model="keywords" @keyup.enter="search"/>
                        <div class="btn layout_flex_center" @click="search">{{ $t('search') }}</div>
                    </div>
                    <div v-else></div>
                    <router-link class="qa" v-if="showQAPath.some(v => $route.path == v)" to="/talents/qa">{{ $t('qa') }}</router-link>
                </div>
            </div>
        </div>
        <keep-alive include="artistList">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<style scoped lang="scss">
.menu{
    gap: .2rem;
    padding: .7rem 0 .6rem;
    @media only screen and (max-width: 750px) {
        width: 100%;
        padding: 0;
        gap: 0;
        // margin-bottom: .3rem;
    }
    .qa{
        font-size: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .22rem;
            color: #999;
        }
    }
    .search_mobile{
        padding: .2rem .3rem;
        border-bottom: 1px solid #999;
    }
    .search{
        gap: .2rem;
        color: #999;
        @media only screen and (max-width: 750px) {
            gap: .1rem;
        }
        input,
        .btn{
            font-size: .22rem;
            height: .5rem;
            border-radius: .1rem;
            border: 1px solid #999;
            padding: 0 .2rem;
        }
        input{
            width: 2.7rem;
            @media only screen and (max-width: 750px) {
                width: 4.5rem;
                height: .5rem;
            }
        }
        .btn{
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                padding: 0 .15rem;
            }
        }
    }
}
.list{
    position: relative;
    @media only screen and (max-width: 750px) {
        width: 100%;
        border-bottom: 1px solid #999;
    }
    &::after{
        content: "";
        width: 100%;
        border-bottom: 1px solid #999;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: -1;
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    .item{
        border-radius: .1rem .1rem 0 0;
        text-align: center;
        color: #666;
        height: .5rem;
        font-size: .22rem;
        cursor: pointer;
        padding: 0 .1rem;
        border: 1px solid transparent;
        &.checked{
            border-color: #333;
            color: #333;
        }
        @media only screen and (max-width: 750px) {
            border: none;
            color: #999;
            height: .86rem;
            font-size: .26rem;
        }
    }
    &.type1{
        @media only screen and (max-width: 750px) {
            height: 1rem;
            gap: 0;
        }
        .item{
            min-width: 1.2rem;
            font-size: .26rem;
            font-weight: bold;
            @media only screen and (max-width: 750px) {
                width: auto;
                height: auto;
                flex: 1;
                font-size: .28rem;
                border-right: 1px solid #999;
                border-radius: 0;
                &:last-child{
                    border-right: none;
                }
            }
        }
    }
    &.type2{
        @media only screen and (max-width: 750px) {
            padding: 0 .3rem;
            gap: 1rem;
            overflow: hidden;
            overflow-x: scroll;
            white-space: nowrap;
            .item{
                padding: 0;
            }
        }
    }
    &.small_text{
        .item{
            font-size: .18rem;
            @media screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
    }
}
.category{
    font-size: .2rem;
    margin-top: .2rem;
    .item{
        line-height: .35rem;
        padding: 0 .1rem;
        border-bottom: 1px solid transparent;
        cursor: pointer;
        &.checked{
            border-color: #000;
        }
    }
    @media only screen and (max-width: 750px) {
        border-bottom: 1px solid #999;
        width: 100%;
        font-size: .26rem;
        padding: 0 .3rem;
        margin: 0;
        height: .8rem;
        .item{
            line-height: normal;
            border-bottom: none;
            color: #999;
            &.checked{
                color: #333;
            }
        }
    }
}
</style>